import { useState } from 'react';

const useCustomHook = () => {
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [totalCount, settotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [debits, setDebits] = useState([]);
  const [isWalletsLoading, setIsWalletsLoading] = useState(false);
  const [wallets, setWallets] = useState([]);

  return {
    isPageLoading,
    setIsPageLoading,
    totalCount,
    settotalCount,
    page,
    setPage,
    debits,
    setDebits,
    isWalletsLoading,
    setIsWalletsLoading,
    wallets,
    setWallets,
  };
};

export default useCustomHook;
